import * as React from 'react';
import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import LinearProgressInternal from '../common/LinearProgress';

const useStyles = makeStyles({
    instructionText: {
        textAlign: 'center',
        marginLeft: ElementDimensions.margin5 + 'px',
        marginRight: ElementDimensions.margin5 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px ',
        marginTop: ElementDimensions.margin5 + 'px ',
    },
    progress: {
        marginRight: '-8px !important',
    },
});

export interface SplitProgressProps {
    progress: number;
    label: string;
}

const SplitProgress = (props: SplitProgressProps) => {
    const { label, progress } = props;
    const classes = useStyles();
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);

    return (
        <div>
            <LinearProgressInternal value={progress} className={classes.progress} />
            <Typography variant="body1" className={classes.instructionText}>
                {label}
            </Typography>
        </div>
    );
};

export default SplitProgress;